import { render, staticRenderFns } from "./LanguageAddEdit.vue?vue&type=template&id=f55f278e"
import script from "./LanguageAddEdit.vue?vue&type=script&lang=js"
export * from "./LanguageAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports